export default (searchTerm) => {
  let sanitizedSearchTerm = searchTerm.replace(/ /g, '-')
  sanitizedSearchTerm = sanitizedSearchTerm.replace(/[?/%#&]/g, '')
  return sanitizedSearchTerm
}
